<p #containerRef id="slick-file-drop_{{uuid}}" class="slick-file-drop">
    <i class="far fa-cloud-arrow-up me-1"></i> {{displayText}}
</p>
<input *ngIf="allowVideos" type="file" #fileInput style="display: none" multiple />
<input *ngIf="!allowVideos" type="file" #fileInput style="display: none" 
       multiple
       accept="image/*,.pdf,.doc,.docx,.xls,.xlsx" />
